import { Cache } from "memory-cache";
import { CharacterFittingEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedFittingEntity(fitting: number): Promise<CharacterFittingEntity | null> {
  let entity: any = await cache.get(fitting.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedFittingEntity(fitting: CharacterFittingEntity) {
  cache.put(fitting.props.id, fitting, 60 * 60 * 1000 /* 1 hour */);
}
